import Config from "../Config";
import { format, parse, subMonths } from 'date-fns'

export function cleanUrl(str) {
    return str?.toString()               // Convert to string
        .normalize('NFD')               // Change diacritics
        .replace(/[\u0300-\u036f]/g, '') // Remove illegal characters
        .replace(/\s+/g, '-')            // Change whitespace to dashes
        .toLowerCase()                  // Change to lowercase
        .replace(/&/g, '-and-')          // Replace ampersand
        .replace(/[^a-z0-9\-]/g, '')     // Remove anything that is not a letter, number or dash
        .replace(/-+/g, '-')             // Remove duplicate dashes
        .replace(/^-*/, '')              // Remove starting dashes
        .replace(/-*$/, '')
        .toLowerCase();
}


export function getImageUrl({ src, width, height }) {
    let query = '';
    if (width) {
        query += `?w=${width}`;
    }
    if (height) {
        if (query.length > 0) {
            query += `&h=${height}`;
        } else {
            query += `?h=${height}`;
        }
    }

    return `${Config.CDN_URL}/${src}${query}`;
}


export function isBlank(str) {
    return (!str || /^\s*$/.test(str));
}

export function getAktifDonem() {
    const before = subMonths(new Date(), 1);
    return format(before, "yyyy-MM");
}

export function getOncekiDonem(donem, miktar = 11) {
    const date = parse(donem, "yyyy-MM", new Date());
    const before = subMonths(date, miktar);
    return format(before, "yyyy-MM");
}


export const capitalizeFirstChar = (text) => {
    if (!text) return text; // Check for empty or undefined string
    return text.charAt(0).toUpperCase() + text.slice(1);
};

export const imageToByteArray = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.readAsArrayBuffer(file);
        reader.onloadend = () => {
            const arrayBuffer = reader.result;
            const byteArray = new Uint8Array(arrayBuffer);
            resolve(byteArray);
        };

        reader.onerror = (error) => reject(error);
    });
};
